import SessionNew from './session-new-component'

export default SessionNew
